export default {
	label: 'Sätted',
	adminRightsAreMissing: 'Admin õigused puuduvad!',
	customFieldsRights: 'Lisaväljade vaade ei ole saadaval "Kõik asutused" vaates!',
	EITS: 'Eesti Infoturbestandard (E-ITS)',
	RIA: 'Riigi Infosüsteemi Amet (RIA)',
	CC: 'CC BY 4.0',
	version: 'Versioon',
}
